import { useEffect, useState } from "react";
import api from "@/lib/api";
import StatusBadge from "@/components/common/StatusBadge";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Ekyc() {
  const [items, setItems] = useState([]);
  const [status, setStatus] = useState("");
  const [busy, setBusy] = useState(false);

  const load = async () => {
    setBusy(true);
    const params = new URLSearchParams();
    if (status) params.set("status", status);
    const { data } = await api.get(`/api/admin/ekyc?${params.toString()}`);
    setItems(data); setBusy(false);
  };
  useEffect(() => { load(); }, [status]);

  const setSt = async (rec, st) => {
    await api.patch(`/api/admin/ekyc/${rec.id}`, { status: st });
    toast.success(`Updated → ${st}`);
    load();
  };

  return (
    <div className="space-y-6" data-testid="ekyc-page">
      <div className="flex items-center justify-between">
        <div className="text-[var(--text-2)] text-sm">
          eKYC integration is <span className="badge badge-warning">MOCKED</span> — provider abstraction is in place for swap-in.
        </div>
        <select value={status} onChange={(e) => setStatus(e.target.value)}
                className="px-3 py-2 bg-[var(--surface)] border border-[var(--border)] rounded text-sm" data-testid="ekyc-status-filter">
          <option value="">All</option><option value="pending">Pending</option><option value="verified">Verified</option><option value="rejected">Rejected</option><option value="manual_review">Manual review</option><option value="suspended">Suspended</option>
        </select>
      </div>
      <div className="card-surface overflow-hidden">
        <table className="aggr-table">
          <thead><tr><th>Player</th><th>Operator</th><th>Status</th><th>Notes</th><th>Created</th><th></th></tr></thead>
          <tbody>
            {busy && <tr><td colSpan={6} className="text-center py-6"><Loader2 className="inline animate-spin" size={14}/></td></tr>}
            {!busy && items.map(k => (
              <tr key={k.id}>
                <td className="font-mono text-xs">{k.player_id}</td>
                <td className="font-mono text-xs">{k.operator_id}</td>
                <td><StatusBadge status={k.status}/></td>
                <td className="text-xs text-[var(--text-2)]">{k.notes}</td>
                <td className="text-xs text-[var(--text-3)] font-mono">{new Date(k.created_at).toLocaleString()}</td>
                <td>
                  <div className="flex gap-1">
                    <button onClick={() => setSt(k, "verified")} className="badge badge-success" data-testid={`ekyc-verify-${k.id}`}>Verify</button>
                    <button onClick={() => setSt(k, "rejected")} className="badge badge-error" data-testid={`ekyc-reject-${k.id}`}>Reject</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
